import { Radio as AntdRadio } from 'antd';
import type { ComponentProps } from 'react';

import styles from './radio.module.scss';

export type RadioProps = ComponentProps<typeof AntdRadio>;

export function Radio({ className, ...rest }: RadioProps) {
  return <AntdRadio {...rest} className={[styles.radio, className].filter(Boolean).join(' ')} />;
}

export type RadioGroupProps = ComponentProps<typeof AntdRadio.Group>;

/** Thin pass-through so consumers never import antd directly. */
export function RadioGroup(props: RadioGroupProps) {
  return <AntdRadio.Group {...props} />;
}
